<template>
  <div class="md-layout page-feedback">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("Booking Detail") }}</h3>
      </md-toolbar>
      <br />
    </div>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" style="text-align: right;">
      <md-button class="md-primary" style="width:200px; margin-bottom: 20px;" @click="goBack">Go Back</md-button>
    </div>
    <div v-for="item in packageList" :key="item._id.$oid" class="md-layout-item"
      :class="packageList && packageList.length > 1 ? 'md-size-50' : 'md-size-100'">
      <md-card class="md-card-contact">
        <md-card-header class="md-card-header-primary text-center">
          <h4 class="title" style="color:white">
            {{ item.title }}
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <div>
              <label>{{ $t("Client Name") }}: </label>
              <span>{{ reviewInfo.customer_name }}</span>
            </div>
      
            <div style="display: flex; align-items: center;">
              {{ $t("Start Time") }}: <md-button @click="showUpdateTimePopFn(item)" class="md-just-icon md-simple"
                :class="+item.item_status === 0 ? 'md-primary' : ''">
                <md-icon>edit_calendar</md-icon>
              </md-button>
            </div>
            <div v-if="item.start_time">
              {{
                item.start_time &&
                moment(item.start_time.$date)
                  .tz(reviewInfo.review_timezone)
                  .format("YYYY-MM-DD HH:mm")
              }}
                    -
                    {{
                  item.end_time &&
                  moment(item.end_time.$date)
                    .tz(reviewInfo.review_timezone)
                    .format("HH:mm")
                }}
              <div>({{ reviewInfo.review_timezone }})</div>
            </div>
            <div v-if="item.start_time">
              <div v-if="item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.TRAINING" style="display: flex; align-items: center;">
                <label>{{ $t("Training Status") }}: </label>
                <md-checkbox :disabled="+item.item_status !== 0" v-model="item.unsettledStatus" :value="3">{{$t('Completed')}}</md-checkbox>
              </div>
              <div v-if="item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.REVIEW">
                <label>{{ $t("Flight Review Status") }}: </label>
                <md-radio :disabled="+item.item_status !== 0" v-model="item.unsettledStatus" :value="1">{{ $t("Pass") }}</md-radio>
                <md-radio :disabled="+item.item_status !== 0" v-model="item.unsettledStatus" :value="2">{{ $t("Fail") }}</md-radio>
              </div>
              <div v-if="item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.REVIEW">
                <validated-text-input prefix="FR" :placeholder="$t('Flight Review No')" :name="$t('Flight Review No')"
                  v-model="item.flight_review_no" />
              </div>
              <div>
                <md-field>
                  <label>{{ $t("Your Comment") }}</label>
                  <md-textarea v-model="item.description"></md-textarea>
                </md-field>
              </div>
            </div>
          </div>
        </md-card-content>
        <md-card-actions v-if="item.start_time">
          <md-button :disabled="loading" class="md-primary" @click="sendFeedback(item)">{{ $t("Submit") }}</md-button>
        </md-card-actions>
      </md-card>
      <UpdateBookingTimePop v-if="showUpdateTimePop" :onclose="closeUpdateTimePop" :onsave="saveUpdateTimePop" :visiable="true" :bookingInfo="selectedBooking" :order_id="reviewInfo._id.$oid" />
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { updateBookingStatus, reviewerGetOrderItems } from "@/services/flightReview.service.js";
import ValidatedTextInput from "@/components/Inputs/ValidatedTextInput.vue";
import UpdateBookingTimePop from "./bricks/UpdateBookingTimePop.vue";
import moment from "moment-timezone";
import { FLIGHT_REVIEW_PACKAGE_TYPE } from "@/const.js";

export default {
  data() {
    return {
      FLIGHT_REVIEW_PACKAGE_TYPE,
      loading: false,
      reviewInfo: {},
      packageList: [],
      showUpdateTimePop: false,
      selectedBooking: {}
    };
  },
  components: {
    UpdateBookingTimePop,
    ValidatedTextInput
  },
  mounted() {
    const {
      info
    } = this.$route.query;
    this.reviewInfo = JSON.parse(info || "{}");
    this.reviewerGetOrderItems()
  },
  methods: {
    moment: function (date) {
      return moment(date);
    },
    async sendFeedback(item) {
      if ([1, 2, 3].indexOf(item.unsettledStatus) === -1) {
        this.$notify({
          message: item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.REVIEW ? this.$t("Please select a flight review status") : this.$t("Only completed status can add comments"),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
        return;
      }

      if (item.package_type === FLIGHT_REVIEW_PACKAGE_TYPE.REVIEW && !/^\d{10}$/.test(item.flight_review_no)) {
        this.$notify({
          message: this.$t("The Flight Review No field must be numeric and exactly contain 10 digits."),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
        return;
      }

      if (this.loading) return;

      const _self = this;
      swal
        .fire({
          text: this.$t("Do you want to submit now?"),
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(async function({ value }) {
          if (!value) return;
          _self.loading = true;
          try {
            const { id } = _self.$route.query;
            await updateBookingStatus({
              order_id: id,
              item_id: item._id.$oid,
              item_status: item.unsettledStatus,
              flight_review_no: item.flight_review_no ? "FR" + item.flight_review_no : '',
              description: item.description
            });
            _self.loading = false;
            _self.$router.replace("/flight-review/reviewerBookingList");
          } catch {
            _self.loading = false;
          }
        });
    },
    goBack() {
      this.$router.back(-1);
    },
    showUpdateTimePopFn(item) {
      if (+item.item_status !== 0) {
        return
      }
      this.showUpdateTimePop = true;
      this.selectedBooking = item;
    },
    closeUpdateTimePop() {
      this.showUpdateTimePop = false;
    },
    reviewerGetOrderItems() {
      reviewerGetOrderItems(this.reviewInfo._id.$oid).then(res => {
        this.packageList = res.map(item => {
          item.flight_review_no = (item.flight_review_no || "").replace("FR", "")
          item.unsettledStatus = +item.item_status
          return item
        })
      })
    },
    saveUpdateTimePop() {
      this.showUpdateTimePop = false;
      this.$notify({
        message: this.$t("Time update successful"),
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success",
        timeout: 3000
      });
      this.reviewerGetOrderItems()
    },
  }
};
</script>

<style lang="scss">
.page-feedback {
  .md-disabled .md-checkbox-label,
  .md-disabled .md-checkbox-container,
  .md-checked.md-disabled .md-checkbox-container,
  .md-radio.md-disabled .md-radio-label,
  .md-radio.md-disabled .md-radio-container {
    opacity: 0.7;
    cursor: not-allowed;
  }
}
</style>
